import script from "./UserItemView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserItemView.vue?vue&type=script&setup=true&lang=ts"

import "@/views/user/UserItemView.css?vue&type=style&index=0&id=619b308a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619b308a"]])

export default __exports__